import styled from 'styled-components/native';

import { separatorWidth } from '@src/configuration/constants';

type Props = {
  level?: number;
};

const Component = styled.View<Props>`
  padding: ${({ level = 1 }) => (separatorWidth / 2) * level}px;
`;

Component.displayName = 'Separator';

export default Component;
